/*

? First, let's import the interface that will describe the shape of our boost object.

*/

import StateInterface from "../state-interface";

export const ai_boost_leads: StateInterface["ai_boost_leads"] = {
	_id: "",
	property_id: "",
	name: "",
	boost_id: "",
	phone: {
		country_code: "",
		phone_number: ""
	},
	email: "",
	remarks: "",
	source: "",
	status: "",
	qa: [],
	campaign_id: "",
	ad_id: "",
	adset_id: "",
	created_at: "",
	assigned_to: [],
	campaign_name: "",
	adset_name: "",
	form_name: "",
	ad_name: "",
	activity_log: [],
	enquiry_count: 0,
	last_enquiry_at: "",
	lead_id: "",
	gclid: "",
	gbraid: "",
	wbraid: "",
	google_keyword: null
};
